export const loyaltyLevels = [
  {
    id: 'standard',
    name: 'Стандартный',
    subtitle: 'Для всех новых участников',
    color: '#00f5ff',
    glowColor: '#00f5ff',
    cardGradient: 'linear-gradient(135deg, #0a2a2e 0%, #0d3d44 50%, #0a2a2e 100%)',
    borderColor: '#00f5ff',
    icon: 'ri-vip-crown-line',
    minSpend: 0,
    maxSpend: 9999,
    cashback: 1,
    welcomeBonus: 100,
    birthdayBonus: 100,
    appBonus: null,
    seniorBonus: null,
    benefits: [
      { icon: 'ri-percent-line', text: 'Оплата баллами до 99% стоимости товара', highlight: '99%' },
      { icon: 'ri-gift-2-line', text: '100 приветственных баллов при регистрации', highlight: '100' },
      { icon: 'ri-cake-line', text: '100 баллов в день рождения', highlight: '100' },
      { icon: 'ri-coins-line', text: '1% кэшбэк баллами с каждой покупки', highlight: '1%' },
      { icon: 'ri-price-tag-3-line', text: 'Скидки на товары по акции', highlight: null },
      { icon: 'ri-heart-line', text: 'Персональные предложения на любимые товары', highlight: null },
    ],
  },
  {
    id: 'gold',
    name: 'Золотой',
    subtitle: 'Для пенсионеров и покупателей от 10 000 ₽/год',
    color: '#f0ff00',
    glowColor: '#f0c000',
    cardGradient: 'linear-gradient(135deg, #1a1500 0%, #2d2200 50%, #1a1500 100%)',
    borderColor: '#f0c000',
    icon: 'ri-vip-crown-fill',
    minSpend: 10000,
    maxSpend: null,
    cashback: 3,
    welcomeBonus: 100,
    birthdayBonus: 150,
    appBonus: 5,
    seniorBonus: 15,
    benefits: [
      { icon: 'ri-percent-line', text: 'Оплата баллами до 99% стоимости товара', highlight: '99%' },
      { icon: 'ri-gift-2-line', text: '100 приветственных баллов при регистрации', highlight: '100' },
      { icon: 'ri-cake-line', text: '150 баллов в день рождения', highlight: '150' },
      { icon: 'ri-coins-line', text: '3% кэшбэк баллами с каждой покупки', highlight: '3%' },
      { icon: 'ri-smartphone-line', text: '5% бонусов за заказы в мобильном приложении', highlight: '5%' },
      { icon: 'ri-user-heart-line', text: 'До 15% по акции «С уважением к старшим»', highlight: '15%' },
      { icon: 'ri-heart-line', text: 'Персональные предложения', highlight: null },
      { icon: 'ri-vip-diamond-line', text: 'Специальные цены для участников', highlight: null },
    ],
  },
];

export const loyaltyHowItWorks = [
  {
    step: '01',
    icon: 'ri-user-add-line',
    title: 'Зарегистрируйтесь',
    description: 'Создайте аккаунт на сайте или в мобильном приложении. Получите виртуальную карту мгновенно.',
    color: '#ff2d78',
  },
  {
    step: '02',
    icon: 'ri-shopping-bag-line',
    title: 'Совершайте покупки',
    description: 'Называйте номер телефона или показывайте штрихкод карты при каждой покупке в аптеке.',
    color: '#00f5ff',
  },
  {
    step: '03',
    icon: 'ri-coins-line',
    title: 'Копите баллы',
    description: 'Баллы начисляются автоматически. 1 балл = 1 рубль. Баллы действуют 30 дней с момента начисления.',
    color: '#39ff14',
  },
  {
    step: '04',
    icon: 'ri-gift-2-line',
    title: 'Тратьте выгодно',
    description: 'Оплачивайте баллами до 99% стоимости любого товара. Без ограничений по ассортименту.',
    color: '#f0ff00',
  },
];

export const loyaltyFaqs = [
  {
    q: 'Как получить карту лояльности?',
    a: 'Зарегистрируйтесь на сайте или в мобильном приложении NEON PHARMA. Виртуальная карта создаётся мгновенно — никаких очередей и пластика. Штрихкод карты доступен в личном кабинете.',
  },
  {
    q: 'Как начисляются баллы?',
    a: 'Баллы начисляются за каждую покупку: 1% на Стандартном уровне и 3% на Золотом. При онлайн-заказах через приложение — дополнительно +5% на Золотом уровне. Баллы действуют 30 дней с момента начисления на покупку от 500 ₽.',
  },
  {
    q: 'Как списать баллы?',
    a: 'Назовите номер телефона или покажите штрихкод карты на кассе. Вы можете оплатить баллами до 99% стоимости любого товара. При онлайн-заказе выберите «Оплатить баллами» в корзине.',
  },
  {
    q: 'Что такое неактивные баллы?',
    a: 'Баллы, начисленные за покупку, становятся активными через 24 часа после совершения покупки. Срок действия баллов — 30 дней с момента начисления. Баллы за день рождения действуют 90 дней.',
  },
  {
    q: 'Как получить Золотой уровень?',
    a: 'Золотой уровень присваивается автоматически при накоплении суммы покупок от 10 000 ₽ за год, а также всем участникам старше 55 лет (пенсионерам) при указании возраста в анкете.',
  },
  {
    q: 'Можно ли передать карту другому человеку?',
    a: 'Нет. Карта лояльности является именной и не подлежит передаче третьим лицам. Баллы начисляются только владельцу карты при предъявлении документа, удостоверяющего личность.',
  },
];

export const loyaltyStats = [
  { value: '2 млн+', label: 'участников программы', icon: 'ri-group-line', color: '#ff2d78' },
  { value: '1 балл', label: '= 1 рубль скидки', icon: 'ri-coins-line', color: '#f0ff00' },
  { value: 'до 99%', label: 'оплата баллами', icon: 'ri-percent-line', color: '#39ff14' },
  { value: '30 дней', label: 'срок действия баллов', icon: 'ri-time-line', color: '#00f5ff' },
];
